/**
 * @generated SignedSource<<be166e2e2b6734867bf6d2e878c0e669>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type profitWellFragment$data = {
  readonly treeMenuReferringInfo: {
    readonly userType: number;
  };
  readonly " $fragmentType": "profitWellFragment";
};
export type profitWellFragment$key = {
  readonly " $data"?: profitWellFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"profitWellFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "profitWellFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeMenuReferringInfo",
      "kind": "LinkedField",
      "name": "treeMenuReferringInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "968147b36825090dbc2f0272ef5175da";

export default node;
